import { memo } from 'motion-utils';

const supportsWaapi = /*@__PURE__*/ memo(() => Object.hasOwnProperty.call(Element.prototype, "animate"));

export { supportsWaapi };
